export default "__VITE_ASSET__DaVvvO02__"